import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M995.137 592.384 635.073 952.448a53.312 53.312 0 0 1-71.36 3.712l356.224-356.224a64 64 0 0 0 0-90.496L495.873 85.312h45.568a53.448 53.448 0 0 1 37.696 15.616l416 416a53.376 53.376 0 0 1 0 75.456zm-128 0L507.073 952.448a53.312 53.312 0 0 1-75.456 0l-416-416A52.992 52.992 0 0 1 0 498.688V138.752c0-29.44 23.872-53.312 53.312-53.376H413.44a53.448 53.448 0 0 1 37.696 15.616l416 416a53.376 53.376 0 0 1 0 75.456zM341.313 341.312a85.312 85.312 0 1 0-170.624 0 85.312 85.312 0 0 0 170.624 0z" /></svg>

const Tag = React.forwardRef((props, ref) => {
  return (
    <IconBase name="tag" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Tag.displayName = 'IconTag'

export default Tag
